import React, {useState, useEffect, useRef} from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { useMediaQuery } from '@material-ui/core';
import { theme } from '../../themes/default-theme';
import ModelLogo from '../../components/multimedia/ModelLogo';
import ModelFloorPlanConfigration from '../ModelFloorPlanConfiguration';
import { useRouter } from 'next/router';

const Wrapper = styled.div`
    padding-left: 20px;
    padding-right: 20px;
    position: relative;
    background: ${theme.palette.lightGrey};
    display: inline-block;
    width: 100%;
    ${theme.breakpoints.up('lg')} {
        padding-left: 40px;
        padding-right: 40px;
    }
    ${theme.breakpoints.down('sm')} { 
    }
`
const Container = styled.div`
    max-width: 1400px;
    margin: auto;
    ${theme.breakpoints.up('md')} {

    }
`

const ModelStepTwoFloorplanConfigurationPage = (props) => {
    const {
        seriesName,
        seriesUrl,
        modelLogo,
        modelFloorplanConfiguration,
        modelPrice,
        dealers
    } = props

    const router = useRouter();
    const [showBuildAndPrice, setShowBuildAndPrice] = useState(false);

    // Media Breakpoint Start
    const desktopView = useMediaQuery(theme.breakpoints.up('md'));
    const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
    // Media Breakpoint End

    useEffect(() => {
        if((document.location.hostname == 'www.jaycoadelaide.com.au') || (document.location.hostname == 'www.jaycoalbertpark.com.au') || (document.location.hostname.indexOf('jayco-com-au.au1.staticlyproject.com') > -1) || (document.location.hostname.indexOf('localhost') > -1)) {
          setShowBuildAndPrice(true);
        } else {
          setShowBuildAndPrice(false);
          router.push('/404');
        }
    }, [])

    // Set Dynamic Width
    const media = useMediaQuery(theme.breakpoints.up('0'));
    const ref = useRef(null);
    const ref2 = useRef(null);
    const [width, setWidth] = useState(0);
    const[containerWidth, setConntainerWidth] = useState(0);
    useEffect(() => {
        if (ref.current && ref.current.clientWidth) {
            setWidth(ref.current.clientWidth);
        }
        function handleWindowResize() {
            if (ref.current && ref.current.clientWidth) {
                setWidth(ref.current.clientWidth);
            }
        }
        window.addEventListener('resize', handleWindowResize);

        if (ref2.current && ref2.current.clientWidth) {
            setConntainerWidth(ref2.current.clientWidth);
        }
        function handleWindowResize2() {
            if (ref2.current && ref2.current.clientWidth) {
                setConntainerWidth(ref2.current.clientWidth);
            }
        }
        window.addEventListener('resize', handleWindowResize2);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
            window.removeEventListener('resize', handleWindowResize2);
        };

    }, [media]);

    return (
        showBuildAndPrice &&
        <>
            <ModelLogo
                {...modelLogo}
            />
            <Wrapper ref={ref}>
                <Container ref={ref2}>
                    <ModelFloorPlanConfigration
                        {...modelFloorplanConfiguration}
                        modelPrice={modelPrice}
                        currentWidth={(width - containerWidth)/2}
                        dealers={dealers && dealers}
                        disablePrice={true}
                    />
                </Container>

            </Wrapper>
        </>
    )
}

ModelStepTwoFloorplanConfigurationPage.propTypes = {
    seriesName: propTypes.string,
    seriesUrl: propTypes.object,
    modelLogo: propTypes.object,
    modelFloorplanConfiguration: propTypes.object,
    modelPrice: propTypes.object,
    dealers: propTypes.array
}

ModelStepTwoFloorplanConfigurationPage.defaultProps = {
    seriesName: null,
    seriesUrl: {},
    modelLogo: {},
    modelFloorplanConfiguration: {},
    modelPrice: {},
    dealers: []
}

export default ModelStepTwoFloorplanConfigurationPage